export default {
    methods: {
        createBlock(providerId, informationBlockId, content, order, onResult) {
            var url = '/api/information_blocks';
            var parameters = {
                information_block_id: informationBlockId,
                content,
                order
            };
            this.request('post', url, parameters, onResult);
        },

        updateBlock(providerId, providerInformationBlockId, content, onResult) {
            var url = '/api/information_blocks/' + providerInformationBlockId;
            var parameters = {
                content
            };
            this.request('put', url, parameters, onResult);
        },

        deleteBlock(providerId, providerInformationBlockId, onResult) {
            var url = '/api/information_blocks/' + providerInformationBlockId;
            this.request('delete', url, {}, onResult);
        },

        updateBlocksOrder(providerId, blocks, onResult) {
            var url = '/api/information_block_order';
            // encode id order
            var pairs = [];
            for (var i in blocks) {
                pairs.push(blocks[i].id + ':' + blocks[i].order);
            }
            var encodedOrderString = pairs.join(',');
            if (encodedOrderString) {
                this.request('put', url, { orders: encodedOrderString }, onResult);
            }
        },

        createQuestion(providerId, questionId, formId, content, isRequired, order, imageFileName, onResult) {
            var url = '/api/questions';
            var parameters = {
                question_id: questionId,
                provider_form_id: formId,
                content,
                order,
                image_file_name: imageFileName,
                is_required: isRequired
            };
            this.request('post', url, parameters, onResult);
        },

        duplicateQuestionOptions(providerId, fromQuestionId, toQuestionId, onResult) {
            this.request('post', '/api/questions/duplicate_options', {
                provider_id: providerId,
                from_question_id: fromQuestionId,
                to_question_id: toQuestionId
            }, onResult);
        },

        updateQuestion(providerId, providerQuestionId, content, isRequired, imageFileName, onResult) {
            var url = '/api/questions/' + providerQuestionId;
            var parameters = {
                image_file_name: imageFileName,
                content,
                is_required: isRequired
            };
            this.request('put', url, parameters, onResult);
        },

        updateQuestionWithImage(providerId, providerQuestionId, content, isRequired, image, onResult) {
            var data = new FormData();
            data.append('image', image, "q_image.png");
            data.append('content', content);
            data.append('is_required', isRequired);
            data.append('_method', 'put');

            var url = '/api/questions/' + providerQuestionId;
            this.request('post', url, data, onResult);
        },

        deleteQuestion(providerId, providerQuestionId, onResult) {
            var url = '/api/questions/' + providerQuestionId;
            this.request('delete', url, {}, onResult);
        },

        updateQuestionsOrder(providerId, questions, onResult) {
            var url = '/api/question_order';
            // encode id order
            var pairs = [];
            for (var i in questions) {
                pairs.push(questions[i].id + ':' + questions[i].order);
            }
            var encodedOrderString = pairs.join(',');
            if (encodedOrderString) {
                this.request('put', url, { orders: encodedOrderString }, onResult);
            }
        },

        updateQuestionOptionsOrder(providerId, options, onResult) {
            var url = '/api/question_option_order';
            // encode id order
            var pairs = [];
            for (var i in options) {
                pairs.push(options[i].id + ':' + options[i].order);
            }
            var encodedOrderString = pairs.join(',');
            if (encodedOrderString) {
                this.request('put', url, { orders: encodedOrderString }, onResult);
            }
        },

        updateBookingNote(bookingId, note, onResult) {
            var url = '/api/bookings/' + bookingId + '/note';
            this.request('put', url, {
                note: note
            }, onResult);
        },

        updateBookingNoteToCustomer(bookingId, note, onResult) {
            var url = '/api/bookings/' + bookingId + '/note_to_customer';
            this.request('put', url, {
                note_to_customer: note
            }, onResult);
        },

        /**
         *  Upload by FormData object for supporting image
         */
        createContentUnit(providerId, providerInformationBlockId, formData, onResult, albumId) {
            var url = '/api/content_units';
            if (providerInformationBlockId) {
                formData.append('provider_information_block_id', providerInformationBlockId);
                if (albumId) {
                    formData.append('album_id', albumId);
                }
            }
            this.request('post', url, formData, onResult);
        },

        updateContentUnit(providerId, contentUnitId, formData, onResult) {
            var url = '/api/content_units/' + contentUnitId;
            formData.append('_method', 'put');
            this.request('post', url, formData, onResult);
        },

        deleteContentUnitImage(contentUnitId, onResult) {
            var url = '/api/content_units/' + contentUnitId + '/image';
            this.request('delete', url, {}, onResult);
        },

        deleteContentUnit(providerId, contentUnitId, onResult) {
            var url = '/api/content_units/' + contentUnitId;
            this.request('delete', url, {}, onResult);
        },

        createOptionContentUnit(providerId, providerQuestionId, formData, onResult) {
            var url = '/api/content_units';
            formData.append('provider_question_id', providerQuestionId);
            this.request('post', url, formData, onResult);
        },

        updateOptionContentUnit(providerId, contentUnitId, formData, onResult) {
            var url = '/api/content_units/' + contentUnitId;
            formData.append('_method', 'PUT');
            this.request('post', url, formData, onResult);
        },

        deleteOptionContentUnit(providerId, contentUnitId, onResult) {
            var url = '/api/content_units/' + contentUnitId;
            this.request('delete', url, {}, onResult);
        },

        getFilterOptions(onResult) {
            this.request('get', '/api/filter_options', {}, onResult);

        },

        updateLandingDisplay(landingMemberLabel, landingServiceLabel, landingBookLabel, landingChooseTimeLabel, landingChooseEndTimeLabel, onResult) {
            var url = '/api/landing_display';
            this.request('put', url, {
                landing_member_label: landingMemberLabel,
                landing_service_label: landingServiceLabel,
                landing_book_label: landingBookLabel,
                landing_choose_time_label: landingChooseTimeLabel,
                landing_choose_end_time_label: landingChooseEndTimeLabel
            }, onResult);
        },

        updateHero(providerId, sloganTitle, sloganSubtitle, contentUnitIds, logoContentUnitId, onResult) {
            var url = '/api/hero';
            this.request('post', url, {
                slogan_title: sloganTitle,
                slogan_subtitle: sloganSubtitle,
                content_unit_ids: contentUnitIds,
                logo_content_unit_id: logoContentUnitId
            }, onResult);
        },

        updateTheme(providerId, themeBackgroundHex, themeTintHex, onResult) {
            var url = '/api/theme';
            this.request('put', url, {
                theme_tint_hex: themeTintHex,
                theme_background_hex: themeBackgroundHex,
            }, onResult);
        },

        updateFaviconHash(providerId, faviconHash, onResult) {
            var url = '/api/favicon_hash';
            this.request('put', url, {
                favicon_hash: faviconHash,
            }, onResult);
        },

        updateOfferModuleEnabled(providerId, offerModuleEnabled, onResult) {
            var url = '/api/offer_module_enabled';
            this.request('put', url, {
                offer_module_enabled: offerModuleEnabled
            }, onResult);
        },

        updateLineLoginSetting(providerId, params, onResult) {
            var url = '/api/line_login_setting';
            this.request('put', url, {
                line_login_channel_id: params.channelId,
                line_login_channel_secret: params.channelSecret,
            }, onResult);
        },

        updateLineMessageSetting(providerId, params, onResult) {
            var url = '/api/line_message_setting';
            this.request('put', url, {
                line_message_channel_id: params.channelId,
                line_message_channel_secret: params.channelSecret,
            }, onResult);
        },

        getCustomerAllCoupons(onResult) {
            this.request('get', '/api/customer/offers', {}, onResult);
        },

        getOfferLimitItems(offerId, onResult) {
            this.request('get', '/api/offers/' + offerId + '/limit_items', {}, onResult);
        },

        getCustomerCouponsByAdmin(customerId, page, onResult) {
            this.request('get', `/api/customer_offers?page=${page}&customer_id=${customerId}`, {}, onResult);
        },

        getAvailableCustomerCoupons(onResult) {
            this.request('get', '/api/available_customer_offers', {}, onResult);
        },

        redeemCustomerOffer(customerOfferId, password, onResult) {
            this.request('put', `/api/customer_offer/${customerOfferId}/redeem`, { password }, onResult);
        },

        createCustomerOffers(query /* CustomerQuery */, couponId, message, onResult) {
            var url = '/api/customer_offers?payload=' + encodeURIComponent(JSON.stringify(query.toPayload()));
            this.request('post', url, {
                offer_id: couponId,
                message
            }, onResult);
        },

        // private
        // consider frontend only isSplitted related attributes
        _mapCartItemsForBackend(cartItems, withOfferItems = true) {
            return cartItems.filter(item => !item.campaign_id).map((item) => {
                if (item.specId) {
                    return {
                        spec_id: item.specId,
                        count: item.count,
                        is_splitted: !!item.isSplitted,
                        renting_charge_amount: item.renting_charge_amount,
                        renting_charge_type: item.renting_charge_type,
                        applied_pricing_rule_id: item.appliedPricingRule?.id
                    };
                } else if (item.itemId) {
                    return {
                        item_id: item.itemId,
                        count: item.count,
                        is_splitted: !!item.isSplitted,
                        renting_charge_amount: item.renting_charge_amount,
                        renting_charge_type: item.renting_charge_type,
                        applied_pricing_rule_id: item.appliedPricingRule?.id,
                        price: item.price,
                        total: item.total
                    };
                } else if (item.offer_id && withOfferItems) {
                    return {
                        offer_id: item.offer_id,
                        code: item.offer.promo_code ? item.offer.promo_code : null
                    }
                } else if (item.serviceId) {
                    return {
                        service_id: item.serviceId,
                        count: 1,
                        price: item.price,
                        total: item.total
                    };
                } else if (item.booking_pass_id) {
                    return {
                        booking_pass_id: item.booking_pass_id,
                        count: item.count,
                        price: item.price,
                        total: item.total
                    };
                }
            });
        },

        getCampaignsDiscountAmount(cartItems, start, end, levelId, serviceId, campaigns, onResult) {
            const orderItems = this._mapCartItemsForBackend(cartItems);
            campaigns.forEach(campaign => {
                orderItems.push({ campaign_id: campaign.id });
            })
            this.request('post', '/api/cart/check_offers', {
                order_items: orderItems, 
                start, end,
                service_id: serviceId,
                level_id: levelId,
            }, onResult);
        },

        getOfferDiscountAmount(cartItems, start, end, serviceId, levelId, offer, onResult) {
            // 這裡 cartItems 中沒有 offerItem
            let orderItems = this._mapCartItemsForBackend(cartItems, false);
            // 要另外加進去，並且只會有一個 offerItem
            orderItems.push({
                offer_id: offer.id,
                code: offer.promo_code ? offer.promo_code : null
            })
            this.request('post', '/api/cart/check_offers', {
                order_items: orderItems, 
                start, end,
                service_id: serviceId,
                level_id: levelId,
            }, onResult);
        },

        getOfferReview(start, end, offerId, onResult) {
            let url = `/api/offer_review?start=${start}&end=${end}`;
            if (offerId) {
                url = url + `&offer_id=${offerId}`;
            }
            this.request('get', url, {}, onResult);
        },

        toggleOfferIsArchived(id, type, onResult) {
            this.request('post', '/api/offers/' + id + '/toggle_archived_at', {type},  onResult);
        },

        getProviderEmailCapacity(onResult) {
            var url = '/api/email_stat';
            this.request('get', url, {}, onResult);
        }, 

        archiveBookingPass(id, onResult) {
            this.request('post', `/api/b/booking_passes/${id}/archive`, null,  onResult);
        },

        getCustomerBookingPasses(page, onResult) {
            this.request('get', `/api/customer/booking_passes`, {page}, onResult);
        },

        getCustomerBookingPassesByAdmin(customerId, page, onResult) {
            this.request('get', `/api/customers/${customerId}/booking_passes`, { page }, onResult);
        },

        getAllBookingsForCustomerBookingPass(customerBookingPassId, onResult) {
            this.request('get', `/api/customer/booking_passes/${customerBookingPassId}/bookings`, {}, onResult);
        },

        getAllBookingsForCustomerBookingPassByAdmin(customerId, customerBookingPassId, onResult) {
            this.request('get', `/api/customers/${customerId}/booking_passes/${customerBookingPassId}/bookings`, {}, onResult);
        },

        // endDateTime: provider timezone like `2022-10-22 10:00:00`
        createBooking(providerId, serviceId, memberUserId, date, startTime, endDateTime, informationForm, onResult) {
            var url = '/api/bookings';
            this.request('post', url, {
                service_id: serviceId,
                member_user_id: memberUserId,
                date,
                start_time: startTime,
                end_datetime: endDateTime,
                data: JSON.stringify(informationForm)
            }, onResult);
        },

        updateBookingStatus(providerId, bookingId, status, reason, onResult) {
            var url = '/api/bookings/' + bookingId + '/status';
            this.request('put', url, { status, reason }, onResult);
        },

        getOverlapBookings(bookingId, onResult) {
            var url = '/api/bookings/' + bookingId + '/overlaps';
            this.request('get', url, {}, onResult);
        },

        //
        getBooking(startDate, endDate, status, onResult) {
            var url = '/api/me/calendar/bookings';
            var params = {
                start_date: startDate,
                end_date: endDate
            };
            if (status) {
                params['status'] = status;
            }
            this.request('get', url, { params: params }, onResult);
        },

        sendEmailToProviderBookings(bookingTypeFilter, filtersInEffect, subject, body, onResult) {
            var url = this.decorateUrlForGettingProviderBooking('/api/bookings/send_email', bookingTypeFilter, filtersInEffect);
            this.request('post', url, {subject, body}, onResult);
        },

        sendSmsToProviderBookings(bookingTypeFilter, filtersInEffect, message, onResult) {
            var url = this.decorateUrlForGettingProviderBooking('/api/bookings/send_sms', bookingTypeFilter, filtersInEffect);
            this.request('post', url, {message}, onResult);
        },

        getProviderBooking(bookingTypeFilter, filtersInEffect, page, onResult) {
            var url = this.decorateUrlForGettingProviderBooking('/api/bookings', bookingTypeFilter, filtersInEffect);
            url += '&page=' + page;
            this.request('get', url, {}, onResult);
        },

        getExportProviderBookingUrl(bookingTypeFilter, filtersInEffect) {
            return this.decorateUrlForGettingProviderBooking('/b/bookings/export', bookingTypeFilter, filtersInEffect);
        },
        getExportProviderBookingUrlWithBookingIds(bookingIds) {
            return '/b/bookings/export?bookingIds=' + bookingIds.join(',');
        },
        getExportProviderBookingForTCATUrl(bookingTypeFilter, filtersInEffect) {
            return this.decorateUrlForGettingProviderBooking('/b/bookings/export_tcat', bookingTypeFilter, filtersInEffect);
        },

        decorateUrlForGettingProviderBooking(basePath, bookingTypeFilter, filtersInEffect, onResult) {
            var url = basePath + '?';
            if (bookingTypeFilter) {
                url += ('type=' + bookingTypeFilter)
            }

            if (filtersInEffect !== null) {
                if (filtersInEffect.datetimeStart) {
                    url += "&start=" + filtersInEffect.datetimeStart;
                }
                if (filtersInEffect.datetimeEnd) {
                    url += "&end=" + filtersInEffect.datetimeEnd;
                }
                if (filtersInEffect.serviceIds && filtersInEffect.serviceIds.length > 0) {
                    url += "&services=" + filtersInEffect.serviceIds;
                }
                if (filtersInEffect.bookingPassIds && filtersInEffect.bookingPassIds.length > 0) {
                    url += "&booking_passes=" + filtersInEffect.bookingPassIds;
                }
                if (filtersInEffect.memberIds && filtersInEffect.memberIds.length > 0) {
                    url += "&members=" + filtersInEffect.memberIds;
                }
                if (filtersInEffect.note) {
                    url += "&note=" + filtersInEffect.note;
                }
                if (filtersInEffect.logisticIds && filtersInEffect.logisticIds.length > 0) {
                    url += "&logistics=" + filtersInEffect.logisticIds;
                }
                if (filtersInEffect.bookingId && filtersInEffect.bookingId.length > 0) {
                    url += '&bookingId=' + filtersInEffect.bookingId;
                }
                if (filtersInEffect.keyword && filtersInEffect.keyword.length > 0) {
                    url += '&keyword=' + filtersInEffect.keyword;
                }
                if (filtersInEffect.paymentCondition) {
                    url += '&payment_condition=' + filtersInEffect.paymentCondition;
                }
                if (filtersInEffect.logisticCondition) {
                    url += '&logistic_condition=' + filtersInEffect.logisticCondition;
                }
                if (filtersInEffect.for_printing_all) {
                    url += '&for_printing_all=1';
                }
                if (filtersInEffect.tcat_format) {
                    url += '&tcat_format=' + filtersInEffect.tcat_format;
                }
            }
            return url;
        },

        getCustomerCancelledStat(onResult) {
            this.request('get', '/api/customer_cancelled_stat', {}, onResult);
        },

        updateCustomerCancelledLastCheckAt(onResult) {
            this.request('put', '/api/customer_cancelled_last_check_at', {}, onResult);
        },

        takeLeave(memberUserId, start, end, memo, onResult) {
            var url = '/api/leaves';
            this.request('post', url, {
                user_id: memberUserId,
                start_time: start,
                end_time: end,
                memo: memo
            }, onResult);
        },

        cancelLeave(memberUserId, leaveId, onResult) {
            var url = '/api/leaves/' + leaveId;
            this.request('delete', url, {
                user_id: memberUserId,
            }, onResult);
        },

        getLeaves(memberUserId, start, end, onResult) {
            var url = '/api/members/' + memberUserId + '/leaves';
            this.request('get', url, {
                params: {
                    start_time: start,
                    end_time: end
                }
            }, onResult);
        },

        getAllLeaves(start, end, onResult) {
            var url = '/api/members/all_leaves';
            this.request('get', url, {
                params: {
                    start_time: start,
                    end_time: end
                }
            }, onResult);
        },

        takeExtraHours(memberUserId, start, end, memo, onResult) {
            var url = '/api/extra_hours';
            this.request('post', url, {
                user_id: memberUserId,
                start_time: start,
                end_time: end,
                memo,
            }, onResult);
        },

        cancelExtraHours(memberUserId, extraHoursId, onResult) {
            var url = '/api/extra_hours/' + extraHoursId;
            this.request('delete', url, {
                user_id: memberUserId,
            }, onResult);
        },

        getMemberExtraHours(memberUserId, start, end, onResult) {
            var url = '/api/members/' + memberUserId + '/extra_hours';
            this.request('get', url, {
                params: {
                    start_time: start,
                    end_time: end
                }
            }, onResult);
        },

        cancelServiceLeave(serviceId, leaveId, onResult) {
            var url = '/api/services/' + serviceId + '/leaves/' + leaveId;
            this.request('delete', url, {}, onResult);
        },

        cancelServiceExtraHours(serviceId, extraHoursId, onResult) {
            var url = '/api/services/' + serviceId + '/extra_hours/' + extraHoursId;
            this.request('delete', url, {}, onResult);
        },

        createEmailTempate(title, subject, body, onResult) {
            var url = '/api/email_templates';
            this.request('post', url, {
                template_title: title,
                mail_subject: subject,
                mail_body: body
            }, onResult);
        },

        updateEmailTempate(emailTemplateId, title, subject, body, onResult) {
            var url = '/api/email_templates/' + emailTemplateId;
            this.request('put', url, {
                template_title: title,
                mail_subject: subject,
                mail_body: body
            }, onResult);
        },

        deleteEmailTempate(emailTemplateId, onResult) {
            var url = '/api/email_templates/' + emailTemplateId;
            this.request('delete', url, {}, onResult);
        },

        sendMail(bookingId, subject, body, onResult) {
            var url = '/api/send_mail';
            this.request('post', url, {
                booking_id: bookingId,
                subject, body
            }, onResult);
        },

        getCustomerBookings(customerId, page, onResult) {
            this.request('get', `/api/customers/${customerId}/bookings?page=${page}`, {}, onResult);
        },

        checkPrivatePassword(serviceId, password, onResult) {
            var url = '/api/services/' + serviceId +'/check_password';
            this.request('post', url, {password: password}, onResult);
        },

        getFormQuestions(formId, onResult) {
            var url = '/api/forms/' + formId + '/questions';
            this.request('get', url, {}, onResult);
        },
        
        getServiceFormQuestions(serviceId, onResult) {
            var url = '/api/services/' + serviceId + '/questions';
            this.request('get', url, {}, onResult);
        },

        getServiceLeaves(serviceId, onResult) {
            var url = '/api/services/' + serviceId + '/leaves';
            this.request('get', url, {}, onResult);
        },

        createServiceLeaves(serviceId, start, end, memo, onResult) {
            var url = '/api/services/' + serviceId + '/leaves';
            this.request('post', url, {start_time: start, end_time: end, memo: memo}, onResult);
        },

        getServiceExtraHours(serviceId, start, end, onResult) {
            var url = '/api/services/' + serviceId + '/extra_hours';
            this.request('get', url, {
                params: {
                    start_time: start,
                    end_time: end,
                }
            }, onResult);
        },

        createServiceExtraHours(serviceId, start, end, memo, onResult) {
            var url = '/api/services/' + serviceId + '/extra_hours';
            this.request('post', url, {start_time: start, end_time: end, memo }, onResult);
        },

        createForm(title, onResult) {
            var url = '/api/forms';
            this.request('post', url, { title }, onResult);
        },

        updateForm({id, title, auto_approve_when_order_paid, prevent_empty_bag, force_auto_approve}, onResult) {
            var url = '/api/forms/' + id;
            var payload = {title};
            if (typeof auto_approve_when_order_paid !== 'undefined') {
                payload.auto_approve_when_order_paid = auto_approve_when_order_paid;
            }
            if (typeof force_auto_approve !== 'undefined') {
                payload.force_auto_approve = force_auto_approve;
            }
            if (typeof prevent_empty_bag !== 'undefined') {
                payload.prevent_empty_bag = prevent_empty_bag;
            }
            this.request('put', url, payload, onResult);
        },

        deleteForm(id, onResult) {
            var url = '/api/forms/' + id;
            this.request('delete', url, { }, onResult);
        },

        duplicateForm(id, title, onResult) {
            var url = '/api/forms/' + id + '/duplicate';
            this.request('post', url, { title }, onResult);
        },

        toggleFormIsArchived(id, type, onResult) {
            this.request('post', '/api/forms/' + id + '/toggle_archived_at', {type},  onResult);
        },

        getContractTemplates(onResult) {
            var url = '/api/contract_templates';
            this.request('get', url, { }, onResult);
        },

        createContractTemplate(title, onResult) {
            var url = '/api/contract_templates';
            this.request('post', url, { title }, onResult);
        },

        saveContractTemplate(template, onResult) {
            var url = '/api/contract_templates/' + template.id ;
            this.request('put', url, template, onResult);
        },

        deleteContractTemplate(template, onResult) {
            var url = '/api/contract_templates/' + template.id ;
            this.request('delete', url, template, onResult);
        },

        createGrade(level, onResult) {
            var url = '/api/grades';
            var parameters = {
                level
            };
            this.request('post', url, parameters, onResult);
        },

        updateGrade(gradeId, level, onResult) {
            var url = '/api/grades/' + gradeId;
            var parameters = {
                level
            };
            this.request('put', url, parameters, onResult);
        },

        deleteGrade(gradeId, onResult) {
            var url = '/api/grades/' + gradeId;
            var parameters = {
            };
            this.request('delete', url, parameters, onResult);
        },

        createCapability(title, displayLabel, type, defaultValue, onResult) {
            var url = '/api/capabilities';
            var parameters = {
                title,
                display_label: displayLabel,
                type,
                default: defaultValue
            };
            this.request('post', url, parameters, onResult);
        },

        updateCapability(capabilityId, displayLabel, onResult) {
            var url = '/api/capabilities/' + capabilityId;
            var parameters = {
                display_label: displayLabel
            };
            this.request('put', url, parameters, onResult);
        },

        deleteCapability(capabilityId, onResult) {
            var url = '/api/capabilities/' + capabilityId;
            var parameters = {
            };
            this.request('delete', url, parameters, onResult);
        },

        updateGradeCapability(gradeCapabilityId, enabled, max, onResult) {
            var url = '/api/grade_capabilities/' + gradeCapabilityId;
            var parameters = {
                enabled,
                max
            };
            this.request('put', url, parameters, onResult);
        },

        syncBookingToCalendar(bookingId, onResult) {
            var url = '/api/bookings/' + bookingId + '/push_to_google_calendar';
            this.request('post', url, {}, onResult);
        },

        getUnavailableTimeSlotsForMember(memberUserId, start, end, onResult) {
            var url = '/api/members/' + memberUserId + '/unavailable_time_slots';
            this.request('get', url, { params: { start, end } }, onResult);
        },

        saveBooking(booking, customer, form, orderItems, logistic, onResult) {
            let data = {
                customer,
                questions: form
            }
            if (booking.id) {
                var url = "/api/bookings/" + booking.id;
                var method = 'put';
                data = Object.assign({}, data, {
                    order_items: orderItems,
                    logistic
                })
            } else {
                var url = "/api/bookings";
                var method = 'post';
                data = Object.assign({}, data, {
                    order_items: orderItems,
                    logistic
                })
            }
            this.request(method, url, {
                service_id: booking.service_id,
                member_user_id: booking.member_user_id,
                date: booking.date,
                start_time: booking.start_time,
                note: booking.note,
                end_datetime: booking.end_datetime,
                parent_booking_id: booking.parent_booking_id,
                root_booking_id: booking.root_booking_id,
                data: JSON.stringify(data)
            }, onResult);
        },

        saveMember(member, workingDays, onResult) {
            if (member.id) {
                var url = "/api/members/" + member.id;
                var method = 'put';
            } else {
                var url = "/api/members";
                var method = 'post';
            }
            this.request(method, url, {
                ...member,
                provider_role_id: member.role.id,
                color: member.pivot.color,
                short_id: member.pivot.short_id,
                is_internal: member.pivot.is_internal,
                working_days: JSON.stringify(workingDays)
            }, onResult);
        },

        deleteMember(member, onResult) {
            this.request('delete', '/api/members/' + member.id, {}, onResult);
        },

        restoreMember(member, onResult) {
            this.request('post', '/api/members/' + member.id + '/restore', {}, onResult);
        },

        saveService(service, onResult) {
            if (service.id) {
                var url = "/api/services/" + service.id;
                var method = 'put';
            } else {
                var url = "/api/services";
                var method = 'post';
            }
            this.request(method, url, service, onResult);
        },

        updateServicesOrder(services, onResult) {
            var url = '/api/services_order';
            let servicesOrderedIds = services.map((item) => { return item.id; }).join(',');
            this.request('put', url, { order: servicesOrderedIds }, onResult);
        },

        updateUserProviderOrder(userProviderPivots, onResult) {
            var url = '/api/members_order';
            let membersOrderedIds = userProviderPivots.map((item) => { return item.user_id; }).join(',');
            this.request('put', url, { order: membersOrderedIds }, onResult);
        },

        toggleServiceIsDisabled(serviceId, onResult) {
            this.request('post', '/api/services/' + serviceId + '/toggle_disabled', {},  onResult);
        },

        toggleServiceIsArchived(serviceId, type, onResult) {
            this.request('post', '/api/services/' + serviceId + '/toggle_archived_at', {type},  onResult);
        },

        setAutoVisibility(serviceId, type, datetime, onResult) {
            this.request('post', '/api/services/' + serviceId + '/auto_visibility', {type, datetime},  onResult);
        },

        clearAutoVisibility(serviceId, onResult) {
            this.request('delete', '/api/services/' + serviceId + '/auto_visibility', {},  onResult);
        },

        deleteService(service, onResult) {
            this.request('delete', '/api/services/' + service.id, {}, onResult);
        },

        duplicateService(serviceId, onResult) {
            this.request('post', '/api/services/' + serviceId + '/replicate', {}, onResult);
        },

        checkSubdomainAvailability(subdomain, onResult) {
            this.request('get', '/api/subdomains/availability', { params: { subdomain } }, onResult);
        },

        finishOnboard(setting, onResult) {
            this.request('post', '/api/onboard', { ...setting }, onResult);
        },

        getMailingRecords(bookingId, onResult) {
            this.request('get', '/api/bookings/' + bookingId + '/mailing_records', {}, onResult);
        },

        getBookingSmsRecords(bookingId, onResult) {
            this.request('get', '/api/bookings/' + bookingId + '/sms_records', {}, onResult);
        },

        getBookingLineRecords(bookingId, onResult) {
            this.request('get', '/api/bookings/' + bookingId + '/line_records', {}, onResult);
        },

        getCustomerMailingRecords(customerId, onResult) {
            this.request('get', '/api/customers/' + customerId + '/mailing_records', {}, onResult);
        },

        getCustomerLineRecords(customerId, onResult) {
            this.request('get', '/api/customers/' + customerId + '/line_records', {}, onResult);
        },

        getCustomerSmsRecords(customerId, onResult) {
            this.request('get', '/api/customers/' + customerId + '/sms_records', {}, onResult);
        },

        getBlockedCustomers(page, query /* CustomerQuery */, onResult) {
            this.request('get', '/api/blocked_customers', { params: {
                page,
                payload: JSON.stringify(query.toPayload()),
            }}, onResult);
        },

        createBlockedCustomer(phoneCallingCode, phoneNumber, name, email, note, expiredDate, onResult) {
            this.request('post', '/api/blocked_customers', {
                phone_calling_code: phoneCallingCode,
                phone_number: phoneNumber,
                name,
                email,
                note,
                expired_at: expiredDate
            }, onResult);
        },

        deleteBlockedCustomer(blockedCustomerId, onResult) {
            this.request('delete', '/api/blocked_customers/' + blockedCustomerId, {}, onResult);
        },

        getSubscriptionSummary(gradeId, term, currency, onResult) {
            this.request('get', '/api/subscription/summary', { params: { grade_id: gradeId, term, currency } }, onResult);
        },

        checkCanAddAlbum(onResult) {
            this.request('get', '/api/capabilities/can_add_album', {}, onResult);
        },

        getTWZip(onResult) {
            this.request('get', '/data/tw-zipcode.json', {}, onResult);
        },

        uploadESigning(imageFile, onResult) {
            var data = new FormData();
            data.append('image', imageFile, "e_signing.png");

            var url = '/api/e_signing';
            this.request('post', url, data, onResult);
        },

        uploadCustomerAsset(file, onResult) {
            var data = new FormData();
            data.append('file', file, file.name);

            var url = '/api/customers/assets';
            this.request('post', url, data, onResult);
        },

        deleteCustomerAsset(path, onResult) {
            this.request('delete', '/api/customers/assets?path=' + encodeURIComponent(path), {}, onResult);
        },

        hideCustomer(id, onResult) {
            this.request('delete', `/api/customers/${id}/crm_visibility`, {}, onResult);
        },

        loadContracts(bookingId, onResult) {
            this.request('get', '/api/bookings/' + bookingId + '/contracts', {}, onResult);
        },

        createContract(contract, onResult) {
            this.request('post', '/api/bookings/' + contract.booking_id + '/contracts', contract, onResult);
        },

        updateContract(contract, onResult) {
            this.request('put', '/api/bookings/' + contract.booking_id + '/contracts/' + contract.id, contract, onResult);
        },

        sendContract(contract, bookingId, onResult) {
            this.request('post', '/api/bookings/' + bookingId + '/send_contract', contract, onResult)
        },

        getBookingWithDisplayId(displayId, onResult) {
            this.request('get', '/api/customers/bookings/' + displayId, {}, (response, error, errors, message) => {
                if (response && response.data) {
                    onResult(response.data)
                } else {
                    onResult(response, error, errors, message);
                }
            });
        },

        customerCancelBooking(displayId, onResult) {
            this.request('delete', '/api/customers/bookings/' + displayId, {}, onResult);
        },

        getFileVault(bookingId, onResult) {
            this.request('get', '/api/bookings/' + bookingId + '/file_vault', {},  onResult);
        },

        getFileVaultFiles(hashId, folderId, onResult) {
            var url = '/api/file_vaults/' + hashId + '/files';
            if (folderId) {
                url += '?folder_file_id=' + folderId;
            }
            this.request('get', url, null, onResult);
        },

        uploadFileVaultFile(fileVaultHashId, fileName, file, parentFileId, onResult) {
            var data = new FormData();
            data.append('file', file, fileName);
            if (parentFileId) {
                data.append('parent_file_id', parentFileId);
            }

            var url = '/api/file_vaults/' + fileVaultHashId + '/files';
            this.request('post', url, data, onResult);
        },

        deleteFileVaultFile(fileVaultHashId, fileId, onResult) {
            var url = '/api/file_vaults/' + fileVaultHashId + '/files/' + fileId;
            this.request('delete', url, {}, onResult);
        },

        createFileVaultFolder(fileVaultHashId, name, onResult) {
            var url = '/api/file_vaults/' + fileVaultHashId + '/folders';
            this.request('post', url, {folder_name: name}, onResult);
        },

        inviteCustomerToFileVault(fileVaultHashId, message, onResult) {
            var url = '/api/file_vaults/' + fileVaultHashId + '/invite_customer';
            this.request('post', url, {message}, onResult);
        },

        renameFile(fileVaultHashId, fileId, newName, onResult) {
            var url = '/api/file_vaults/' + fileVaultHashId + '/files/' + fileId;
            this.request('put', url, {name: newName}, onResult);
        },

        getSmsRecords(page, onResult) {
            this.request('get', '/api/sms/records?page=' + page, {}, onResult);
        },

        resendSmsRecord(r, useCustomerNewNumber, onResult) {
            this.request('post', '/api/sms/records/' + r.id + '/resend', {use_customer_new_number: useCustomerNewNumber}, onResult);
        },

        createSmsTempate(title, body, onResult) {
            var url = '/api/sms_templates';
            this.request('post', url, {
                title, body
            }, onResult);
        },

        updateSmsTempate(smsTemplateId, title, body, onResult) {
            var url = '/api/sms_templates/' + smsTemplateId;
            this.request('put', url, {
                title, body
            }, onResult);
        },

        deleteSmsTempate(smsTemplateId, onResult) {
            var url = '/api/sms_templates/' + smsTemplateId;
            this.request('delete', url, {}, onResult);
        },

        sendSms(customerId, bookingId, message, onResult) {
            this.request('post', '/api/sms/records', {
                customer_id: customerId,
                booking_id: bookingId,
                message
            }, onResult);
        },

        getSmsCreditDeposits(page, onResult) {
            this.request('get', '/api/sms/deposits?page=' + page, {}, onResult);
        },

        getSmsPreference(onResult) {
            this.request('get', '/api/sms/preference', {}, onResult);
        },

        updateSmsPreference(preference, onResult) {
            this.request('put', '/api/sms/preference', {
                booking_status_update: preference.booking_status_update ? 1 : 0,
                booking_reminder: preference.booking_reminder ? 1 : 0,
                payment_request: preference.payment_request ? 1 : 0,
                send_coupon: preference.send_coupon ? 1 : 0,
                payment_will_expire_reminder: preference.payment_will_expire_reminder ? 1 : 0,
            }, onResult);
        },

        updateCustomerNotificationSetting(setting, onResult) {
            this.request('put', '/api/customer_notification_setting', setting, onResult);
        },

        updateCustomerNotificationPreference(preference, onResult) {
            this.request('put', '/api/customer_notification_preference', preference, onResult);
        },

        getBookingGroup(ofBookingId, onResult) {
            this.request('get', '/api/bookings/' + ofBookingId + '/group', {}, onResult);
        },

        getBookingPayments(bookingId, onResult) {
            this.request('get', '/api/bookings/' + bookingId + '/payments', {}, onResult);
        },

        switchBookingPaymentToManual(bookingId, paymentId, onResult) {
            this.request('put', `/api/bookings/${bookingId}/payments/${paymentId}/switch_to_manual`, {}, onResult);
        },

        markPaymentPaid(bookingId, paymentId, onResult) {
            this.request('put', `/api/bookings/${bookingId}/payments/${paymentId}/mark_paid`, {}, onResult);
        },

        reportAtmPayment(bookingId, bookingPaymentId, accountLastFiveDigits, transferredAt, image, onResult) {
            var form = new FormData();
            form.append('image', image);
            form.append('account_last_five_digits', accountLastFiveDigits);
            form.append('transferred_at', transferredAt);
            this.request('post', `/api/bookings/${bookingId}/payments/${bookingPaymentId}/atm_reports`, form, onResult);
        },

        createBookingPayment(bookingId, payment, onResult) {
            if (!payment.gateway_name) {
                delete payment.gateway_name;
            }
            this.request('post', '/api/bookings/' + bookingId + '/payments', payment, onResult);
        },

        updatePaymentGateway(name, extras, onResult) {
            this.request('post', '/api/payment_gateways', {
                name, extras: extras, _method: 'put'
            }, onResult);
        },
        deletePaymentGateway(name, onResult) {
            this.request('post', '/api/payment_gateways', {
                name: name, _method: 'delete'
            }, onResult);
        },

        deletePayment(bookingId, paymentId, onResult) {
            this.request('delete', '/api/bookings/' + bookingId + '/payments/' + paymentId, {}, onResult);
        },

        cancelPayment(bookingId, paymentId, onResult) {
            this.request('put', '/api/bookings/' + bookingId + '/payments/' + paymentId + '/cancel_payment', {}, onResult);
        },

        getAvailablePaymentGateways(providerId, onResult) {
            this.request('get', '/api/payment_gateways', {}, onResult);
        },

        // Provider point setting
        getPointSetting(onResult) {
            const url = '/api/point_setting';
            this.request('get', url, {}, onResult);
        },

        createPointSetting(rateDollar, ratePoint, onResult) {
            const url = '/api/point_setting';
            this.request('post', url, {
                rate_dollar: rateDollar,
                rate_point: ratePoint
            }, onResult);
        },

        updatePointSetting(rateDollar, ratePoint, isEnabled, onResult) {
            this.request('put', '/api/point_setting', {
                is_enabled: isEnabled,
                rate_dollar: rateDollar,
                rate_point: ratePoint
            }, onResult);
        },

        getCustomerPointLogsByAdmin(customerId, page, onResult) {
            this.request('get', `/api/customer_point_logs?page=${page}&customer_id=${customerId}`, {}, onResult);
        },

        getCustomerLogsByAdmin(customerId, page, onResult) {
            this.request('get', `/api/customers/${customerId}/logs?page=${page}`, {}, onResult);
        },

        getCustomerPointLogs(page, onResult) {
            this.request('get', `/api/customer/point_logs?page=${page}`, {}, onResult);
        },

        getIGMedia(providerId, clearCache, onResult) {
            let url = '/api/ig_media';
            if (clearCache) {
                url += '?clear_cache=1';
            }
            this.request('get', url, {}, onResult);
        },

        getSMSCode(phoneCallingCode, phoneNumber, onResult) {
            let url = "/api/sms_verifications";
            this.request('post', url, {phone_calling_code: phoneCallingCode, phone_number: phoneNumber}, onResult);
        },

        getCustomer(customerId, onResult) {
            this.request('get', '/api/customers/' + customerId, {}, onResult);
        },

        getRegions(country, onResult) {
            this.request('get', '/api/regions/' + country, {}, onResult);
        },

        getRegionPostalCode(country, city, town, onResult) {
            this.request('get', '/api/regions/postal_code/' + country, {params: { city, town }}, onResult);
        },

        saveCustomerAddress(customerId, address, onResult) {
            var url = `/api/customers/${customerId}/addresses`
            var method = 'post';
            if (address.id) {
                url += `/${address.id}`;
                method = 'put';
            }
            this.request(method, url, address, onResult);
        },

        deleteCustomerAddress(customerId, addressId, onResult) {
            var url = `/api/customers/${customerId}/addresses/${addressId}`
            var method = 'delete';
            this.request(method, url, {}, onResult);
        },

        saveCustomerDate(customerId, date, onResult) {
            var url = `/api/customers/${customerId}/dates`
            var method = 'post';
            if (date.id) {
                url += `/${date.id}`;
                method = 'put';
            }
            this.request(method, url, date, onResult);
        },

        deleteCustomerDate(customerId, dateId, onResult) {
            this.request('delete', `/api/customers/${customerId}/dates/${dateId}`, {}, onResult);
        },

        getProviderTags(onResult) {
            this.request('get', `/api/tags`, {}, onResult)
        },

        createProviderTag(label, color, onResult) {
            this.request('post', `/api/tags`, {label, color}, onResult);
        },

        updateProviderTag(tagId, label, color, onResult) {
            this.request('put', `/api/tags/${tagId}`, {label, color}, onResult);
        },

        deleteProviderTag(tagId, onResult) {
            this.request('delete', `/api/tags/${tagId}`, {}, onResult);
        },

        updateCustomerTag(customerId, tagIds, newTags, onResult) {
            this.request('put', `/api/customers/${customerId}/tags`, {tag_ids: tagIds, new_tags: newTags}, onResult)
        },

        updateCustomerBirthday(customerId, payload, onResult) {
            this.request('put', `/api/customers/${customerId}/birthday`, payload, onResult);
        },

        getProviderLevels(onResult) {
            this.request('get', '/api/levels', {}, onResult);
        },

        createNewLevel(label, description, onResult) {
            this.request('post', '/api/levels', {label, description}, onResult);
        },

        deleteLevel(levelId, onResult) {
            this.request('delete', `/api/levels/${levelId}`, {}, onResult);
        },

        updateLevel(levelId, label, description, onResult) {
            this.request('put', `/api/levels/${levelId}`, {label, description}, onResult);
        },

        updateCustomerLevel(customerId, levelId, onResult) {
            this.request('put', `/api/customers/${customerId}/level`, {level_id: levelId}, onResult);
        },

        updateCustomerPoints(customerId, amount, action, expiredAt, description, onResult) {
            this.request('put', `/api/customers/${customerId}/points`, {
                amount,
                action,
                expired_at: expiredAt,
                description
            }, onResult);
        },

        verifyCustomerSms(customerId, onResult) {
            this.request('put', `/api/customers/${customerId}/sms_verifications`, {}, onResult);
        },

        verifyCustomerSmsAndSetPassword(customerId, password, onResult) {
            this.request('put', `/api/customers/${customerId}/sms_verifications_and_set_password`, { password }, onResult);
        },

        getCustomers(page, query /* CustomerQuery */, onResult) {
            var url = '/api/customers?page=' + page + '&payload=' + encodeURIComponent(JSON.stringify(query.toPayload()));
            this.request('get', url, {}, onResult)
        },

        sendSmsToCustomers(query, message, onResult) {
            var url = '/api/sms/send_sms_to_customers?payload=' + encodeURIComponent(JSON.stringify(query.toPayload()));
            this.request('post', url, { message }, onResult);
        },

        sendMailToCustomers(query, subject, body, onResult) {
            var url = '/api/send_mail_to_customers?payload=' + encodeURIComponent(JSON.stringify(query.toPayload()));
            this.request('post', url, {
                subject, 
                body
            }, onResult);
        },

        getCustomerQuerySummary(query /* CustomerQuery */, onResult) {
            var url = '/api/customer_query_summary?payload=' + encodeURIComponent(JSON.stringify(query.toPayload()));
            this.request('get', url, {}, onResult)
        },

        getEmailTemplates(onResult) {
            this.request('get', '/api/email_templates', {}, onResult);
        },

        getSmsTemplates(onResult) {
            this.request('get', '/api/sms_templates', {}, onResult);
        },

        createCustomer(name, email, phoneCallingCode, phoneNumber, gender, ageGroup, onResult) {
            this.request('post', '/api/customers', {
                name, email,
                phone_calling_code: phoneCallingCode,
                phone_number: phoneNumber,
                gender,
                age_group: ageGroup
            }, onResult);
        },

        updateCustomerNote(customerId, note, onResult) {
            this.request('put', '/api/customers/' + customerId + '/note', {
                note
            }, onResult);
        },

        updateCustomerNoteToCustomer(customerId, note, onResult) {
            this.request('put', '/api/customers/' + customerId + '/note_to_customer', {
                note_to_customer: note
            }, onResult);
        },

        updateCustomerBasicInfo(customerId, name, email, phoneCallingCode, phoneNumber, gender, ageGroup, onResult) {
            this.request('put', '/api/customers/' + customerId, {
                name, email,
                phone_calling_code: phoneCallingCode,
                phone_number: phoneNumber,
                gender,
                age_group: ageGroup,
            }, onResult);
        },

        checkExistingMember(phoneCallingCode, phoneNumber, onResult) {
            this.request('post', '/api/check_existing_customer', {
                phone_calling_code: phoneCallingCode,
                phone_number: phoneNumber
            }, onResult);
        },

        uploadCustomerAvatar(imageData, customerId, onResult) {
            var data = new FormData();
            data.append('image', this.dataURItoBlob(imageData), 'image/jpeg');

            var url = `/api/customers/${customerId}/avatar`;
            this.request('post', url, data, onResult);
        },

        getExportCustomerUrl(query /* CustomerQuery */) {
            return '/b/customers/export?payload=' + encodeURIComponent(JSON.stringify(query.toPayload()));
        },

        getMembers(onResult) {
            this.request('get', '/api/alive_members', {}, onResult)
        },

        getServices(onResult) {
            this.request('get', '/api/services', {}, onResult)
        },

        precheck(serviceId, memberId, start, end, excludeBookingId, onResult) {
            this.request('get', '/api/precheck', {params: {start, end, service_id: serviceId, member_user_id: memberId, exclude_booking_id: excludeBookingId}}, onResult);
        },

        getLoggedInCustomer(onResult) {
            this.request('get', '/api/customer', {}, onResult);
        },

        sortImages(imageIds, onResult) {
            this.request('post', '/api/images/sort', {ids: imageIds.join(',')}, onResult);
        },

        uploadImage(imageableId, imageableType, type, photoFile, onResult) {
            let url = '/api/images/draft';
            let formData = new FormData();

            formData.append('image', photoFile);
            formData.append('imageable_type', imageableType);
            if (type) {
                formData.append('type', type);
            }
            if (imageableId) {
                url = '/api/images';
                formData.append('imageable_id', imageableId);
            }
            this.request('post', url, formData, onResult);
        },

        getItemGroupStockInfo(groupId, date, onResult) {
            if (date) {
                this.request('get', `/api/item_groups/${groupId}/stocks?date=${date}`, {}, onResult);
            } else {
                this.request('get', `/api/item_groups/${groupId}/stocks`, {}, onResult);
            }
        },

        getItemGroupStockInfoInDateRange(groupId, startDate, endDate, onResult) {
            this.request('get', `/api/item_groups/${groupId}/stocks?start_date=${startDate}&end_date=${endDate}`, {}, onResult);
        },

        getOrder(orderId, onResult) {
            var url = '/api/orders/' + orderId;
            this.request('get', url, {}, onResult);
        },

        updateOrder(orderId, items, onResult) {
            this.request('put', `/api/orders/${orderId}`, {items: items}, onResult);
        },

        getCartItemsUnavailableDateByStock(start, end, itemIds, specIds, onResult) {
            this.request('post', `/api/cart/items/stock_unavailable_dates`, {
                start, end,
                item_ids: itemIds, spec_ids: specIds
            }, onResult)
        },

        updateLogisticsOrder(logistics, onResult) {
            var url = '/api/logistics_order';
            let logisticsOrderedIds = logistics.map((item) => { return item.id; }).join(',');
            this.request('put', url, { order: logisticsOrderedIds }, onResult);
        },

        updateInterstitialsOrder(interstitials, onResult) {
            var url = '/api/interstitials_order';
            let interstitialsOrderedIds = interstitials.map((item) => { return item.id; }).join(',');
            this.request('put', url, { order: interstitialsOrderedIds }, onResult);
        },

        saveItemSpecAttributes(itemId, name, values, onResult) {
            var url = `/api/items/${itemId}/spec_attributes`;
            this.request('post', url, { name, values }, onResult);
        },
        
        updateItemSpecAttributes(itemId, attributeId, name, values, onResult) {
            var url = `/api/items/${itemId}/spec_attributes/${attributeId}`;
            this.request('put', url, { name, values }, onResult);
        },

        handleLineLoginSuccess(code, redirectURI, onResult) {
            this.request('post', '/api/line_auth/ok', {
                code,
                redirect_uri: redirectURI
            }, onResult);
        },

        collectOffer(offerId, onResult) {
            this.request('post', '/api/offers/' + offerId + '/collect', {}, onResult);
        },

        // Helpers

        request(method, url, parameters, onResult) {
            var parameters = parameters || {};
            parameters.withCredentials = true;

            axios[method](url, parameters)
                .catch(function (error) {
                    var errors = null;
                    var message = null;
                    if (error && error.response && error.response.data) {
                        errors = error.response.data.errors || {};
                        message = error.response.data.message;
                    }
                    onResult(null, error, errors, message);
                    return Promise.reject();
                })
                .then(function (response) {
                    onResult(response, null);
                })
                .catch(function(error) {
                    //noop
                });
        },
        dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = unescape(dataURI.split(',')[1]);
            }

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type:mimeString });
        },
    }
}
